<!-- Add Subscriber and Spouse-->
@if (showSubscriber || showSpouse) {
  <ng-container *ngTemplateOutlet="subSpouseTemplate"></ng-container>
}

<!-- Dependent -->
@if (showChild || showChildOnly || showParent) {
  <ng-container
    *ngTemplateOutlet="depTemplate; context: { showChildOnly: showChildOnly }"
  ></ng-container>
}

<ng-template #subSpouseTemplate>
  <div class="WhoseCoveredForm">
    <card class="WhoseCoveredForm__WhoseCoveredCardSections">
      <h6 title class="t-bold" data-test-id="whoseCoveredSpouseTitle">
        {{
          showSubscriber
            ? subSpouseConfig?.text?.subscriber
            : subSpouseConfig?.text?.spouse
        }}
      </h6>
      <div header-action>
        @if (showSpouse) {
          <zip-button
            [config]="closeDependentCard"
            (zipButtonClicked)="removeButtonClicked(0, 'spouseDependent')"
            data-test-id="closeSpouseButton"
          >
          </zip-button>
        }
      </div>

      <div subheader>
        @if (maxAgeLimit) {
          <div class="WhoseCoveredForm__Banner WhoseCoveredForm__Banner--Error">
            <p
              class="t-data"
              [innerHTML]="
                config.coverage?.text
                  ?.max_age_subscriber_medicare_or_individual_or_dental
              "
              data-test-id="maxAgeErrorText"
            ></p>
          </div>
        }
        @if (isOverSixtyFive) {
          <div class="WhoseCoveredForm__Banner banner">
            <p
              class="t-data"
              [innerHTML]="config?.coverage?.subscriber?.maxAllowedText"
              data-test-id="maxAllowedText"
            ></p>
          </div>
        }
      </div>

      <div body>
        <div class="WhoseCoveredForm__WhoseCoveredQuestions">
          @for (
            config of subSpouseConfig?.controls;
            track config;
            let i = $index
          ) {
            <div class="WhoseCoveredForm__Form--Controls">
              <form-control
                [group]="
                  showSubscriber
                    ? whoseCoveredGroup.controls.subscriber
                    : whoseCoveredGroup.controls.spouse
                "
                [config]="config"
                [control]="
                  (showSubscriber
                    ? whoseCoveredGroup.controls.subscriber?.controls
                    : whoseCoveredGroup.controls.spouse?.controls)[config.prop]
                "
                data-test-id="'whoseCoveredformControl-' + i"
              >
              </form-control>
            </div>
          }
        </div>
      </div>

      @if (!isSubscriberOnly && !showSpouse) {
        <div footer class="WhoseCoveredForm__WhoseCoveredFooter">
          @if (!addSpouse) {
            <zip-button
              class="WhoseCoveredForm__WhoseCoveredFooterButton"
              [config]="addSpouseButton"
              (zipButtonClicked)="
                buttonClicked(whoseCoveredValue, true, 'spouseDependent')
              "
              data-test-id="addSpouseButton"
            >
            </zip-button>
          }

          @if (!addChild) {
            <zip-button
              class="WhoseCoveredForm__WhoseCoveredFooterButton"
              [config]="addChildButton"
              (zipButtonClicked)="
                buttonClicked(whoseCoveredValue, true, 'childDependent')
              "
              data-test-id="addChildButton"
            >
            </zip-button>
          }
          @if (!addParent && hasParentDependents) {
            <zip-button
              class="WhoseCoveredForm__WhoseCoveredFooterButton"
              [config]="addParentButton"
              (zipButtonClicked)="
                buttonClicked(whoseCoveredValue, true, 'parentDependent')
              "
              data-test-id="addParentButton"
            >
            </zip-button>
          }
        </div>
      }
    </card>
  </div>
</ng-template>

<ng-template #depTemplate let-showChildOnly="showChildOnly">
  @if (showChildOnly) {
    @for (note of childOnlyConfig?.notes; track note; let i = $index) {
      <div class="WhoseCoveredForm__Banner">
        <p class="t-data" data-test-id="'childOnlyNote' + i">{{ note }}</p>
      </div>
    }
  }

  @for (dep of dependentVal; track dep; let i = $index) {
    <div class="WhoseCoveredForm">
      <card class="WhoseCoveredForm__WhoseCoveredCardSections">
        <div title>
          @if (showChild || showChildOnly) {
            <h6 class="t-bold" data-test-id="whoseCoveredChildTitle">
              {{ dependentConfig.text.child }} {{ i + 1 }}
            </h6>
          }
          @if (showParent) {
            <h6 class="t-bold" data-test-id="whoseCoveredParentTitle">
              {{ dependentConfig.text.parent }} {{ i + 1 }}
            </h6>
          }
        </div>

        <div header-action>
          @if (
            (dependentVal.length > 1 && this.showChildOnly) ||
            this.showChild ||
            this.showParent
          ) {
            <zip-button
              [config]="closeDependentCard"
              (zipButtonClicked)="removeButtonClicked(i)"
              data-test-id="closeDependentButton"
            >
            </zip-button>
          }
        </div>

        <div body class="WhoseCoveredForm__WhoseCoveredQuestions">
          @if (showChildOnly) {
            @for (
              config of childOnlyConfig?.controls;
              track config;
              let x = $index
            ) {
              <div
                class="WhoseCoveredForm__DependentControls"
                [ngClass]="{
                  'WhoseCoveredForm__DependentControls--Extra': x > 1,
                }"
              >
                <div class="WhoseCoveredForm__Form--Controls">
                  <form-control
                    [group]="
                      (whoseCoveredGroup?.controls?.dependents?.controls)[i]
                    "
                    [config]="config"
                    [control]="
                      ((whoseCoveredGroup?.controls?.dependents?.controls)[i]
                        ?.controls)[config.prop]
                    "
                    data-test-id="'dependentFormControl-' + x"
                  >
                  </form-control>
                </div>
              </div>
            }
          } @else {
            <ng-container
              *ngTemplateOutlet="depTemplateFormControls"
            ></ng-container>
          }

          <ng-template #depTemplateFormControls>
            @for (
              config of dependentConfig.controls;
              track config;
              let x = $index
            ) {
              <div
                class="WhoseCoveredForm__DependentControls"
                [ngClass]="{
                  'WhoseCoveredForm__DependentControls--Extra': x > 1,
                }"
              >
                <div class="form--controls">
                  <form-control
                    [group]="
                      showChild
                        ? (whoseCoveredGroup?.controls?.dependents?.controls)[i]
                        : (whoseCoveredGroup?.controls?.stepParents?.controls)[
                            i
                          ]
                    "
                    [config]="config"
                    [control]="
                      showChild
                        ? ((whoseCoveredGroup?.controls?.dependents?.controls)[
                            i
                          ]?.controls)[config.prop]
                        : ((whoseCoveredGroup?.controls?.stepParents?.controls)[
                            i
                          ]?.controls)[config.prop]
                    "
                    data-test-id="'dependentFormControl-' + x"
                  >
                  </form-control>
                </div>
              </div>
            }
          </ng-template>
        </div>
        <div footer>
          @if (showChildOnly) {
            <div footer class="WhoseCoveredForm__WhoseCoveredChildFooter">
              @if (
                childOnlyConfig?.childLimit
                  ? dependentVal.length < childOnlyConfig.childLimit
                  : dependentVal.length < depLimit
              ) {
                <zip-button
                  [config]="dependentbuttonConfig"
                  (zipButtonClicked)="
                    buttonClicked(whoseCoveredValue, true, 'child_only')
                  "
                  data-test-id="childOnlyFooterButton"
                >
                </zip-button>
              }
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="depTemplate"></ng-container>
          }
          <ng-template #depTemplate>
            @if (dependentVal.length < depLimit) {
              <zip-button
                [config]="dependentButtonConfig"
                (zipButtonClicked)="buttonClicked(whoseCoveredValue, true)"
                data-test-id="dependentFooterButton"
              >
              </zip-button>
            }
          </ng-template>
        </div>
      </card>
    </div>
  }
</ng-template>
